(function () {
  var root = document.querySelector("[data-todaymerch-home]");
  if (!root) return;

  var revealEls = Array.prototype.slice.call(root.querySelectorAll(".tmf-reveal"));
  var revealObserver = null;
  var reducedMotionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  var desktopMotionQuery = window.matchMedia ? window.matchMedia("(min-width: 1024px)") : null;
  var prefersReducedMotion = Boolean(reducedMotionQuery && reducedMotionQuery.matches);
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = Boolean(connection && connection.saveData);
  var headerResizeObserver = null;
  var revealFrame = null;

  function getHeaderSections() {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll(".shopify-section-group-header-group")
    );

    if (sections.length) return sections;

    var header = document.querySelector(".header-section");
    return header ? [header] : [];
  }

  function syncHeaderHeight() {
    var headerSections = getHeaderSections();
    if (!headerSections.length) return;

    var headerHeight = Math.round(
      headerSections.reduce(function (total, section) {
        return total + section.getBoundingClientRect().height;
      }, 0)
    );
    if (headerHeight > 0) {
      root.style.setProperty("--tmf-home-header-height", headerHeight + "px");
    }
  }

  syncHeaderHeight();
  window.addEventListener("load", syncHeaderHeight, { once: true });
  window.addEventListener("resize", syncHeaderHeight, { passive: true });

  if ("ResizeObserver" in window) {
    var headerSectionsForResize = getHeaderSections();
    if (headerSectionsForResize.length) {
      headerResizeObserver = new ResizeObserver(syncHeaderHeight);
      headerSectionsForResize.forEach(function (section) {
        headerResizeObserver.observe(section);
      });
      root.tmfHeaderResizeObserver = headerResizeObserver;
    }
  }

  function hasEnhancedMotion() {
    var reduced = reducedMotionQuery ? reducedMotionQuery.matches : prefersReducedMotion;
    return !reduced && !saveData && (!desktopMotionQuery || desktopMotionQuery.matches);
  }

  function hasHeroMotion() {
    var reduced = reducedMotionQuery ? reducedMotionQuery.matches : prefersReducedMotion;
    return !reduced && !saveData;
  }

  function hasKeeperMotion() {
    var reduced = reducedMotionQuery ? reducedMotionQuery.matches : prefersReducedMotion;
    return !reduced && !saveData;
  }

  function listenForMediaChange(mediaQuery, listener) {
    if (!mediaQuery) return;
    if (mediaQuery.addEventListener) mediaQuery.addEventListener("change", listener);
    else if (mediaQuery.addListener) mediaQuery.addListener(listener);
  }

  function showReveal(el) {
    el.classList.add("is-visible");
    if (revealObserver) revealObserver.unobserve(el);
  }

  function revealPassedElements() {
    revealFrame = null;
    var revealLine = window.innerHeight * 1.08;
    var passedElements = [];

    revealEls = revealEls.filter(function (el) {
      if (el.classList.contains("is-visible")) return false;

      var rect = el.getBoundingClientRect();
      if (rect.top <= revealLine) {
        passedElements.push(el);
        return false;
      }

      return true;
    });
    // Read all positions before revealing content, so styles do not force another layout.
    passedElements.forEach(showReveal);
    if (!revealEls.length) {
      window.removeEventListener("scroll", requestReveal);
      window.removeEventListener("resize", requestReveal);
    }
  }

  function requestReveal() {
    if (revealFrame === null && revealEls.length) {
      revealFrame = window.requestAnimationFrame(revealPassedElements);
    }
  }

  if ("IntersectionObserver" in window) {
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            showReveal(entry.target);
          }
        });
      },
      { threshold: 0.01, rootMargin: "12% 0px -4% 0px" }
    );
    revealEls.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index * 45, 220) + "ms";
      revealObserver.observe(el);
    });
    revealPassedElements();
    if (revealEls.length) {
      window.addEventListener("scroll", requestReveal, { passive: true });
      window.addEventListener("resize", requestReveal);
    }
  } else {
    revealEls.forEach(function (el) {
      showReveal(el);
    });
  }

  var productCarousel = root.querySelector("[data-tmf-product-carousel]");
  var productRail = root.querySelector("[data-tmf-product-rail]");
  if (productCarousel && productRail) {
    var productCards = Array.prototype.slice.call(productRail.querySelectorAll("[data-tmf-product-card]"));
    var productPrev = productCarousel.querySelector("[data-tmf-product-prev]");
    var productNext = productCarousel.querySelector("[data-tmf-product-next]");
    var productStatus = productCarousel.querySelector("[data-tmf-product-status]");
    var productControls = productCarousel.querySelector("[data-tmf-product-controls]");
    var productTabList = productCarousel.querySelector("[data-tmf-product-tabs]");
    var productTabs = productTabList
      ? Array.prototype.slice.call(productTabList.querySelectorAll("[data-tmf-product-tab]"))
      : [];
    var productCategoryContent = Object.create(null);
    var productCategorySources = Object.create(null);
    var productCategoryRequests = Object.create(null);
    var productCategorySelection = 0;
    var productCategoryLimit = Math.min(24, Math.max(1,
      parseInt(productCarousel.getAttribute("data-tmf-product-limit"), 10) || 24
    ));
    var activeProductCategory = productTabs.length
      ? productTabs[0].getAttribute("data-tmf-product-category")
      : null;
    var productRailFrame = null;
    var productDragThreshold = 6;
    var productDragPointerId = null;
    var productDragStartX = 0;
    var productDragStartScrollLeft = 0;
    var productDragActive = false;
    var suppressNextProductClick = false;
    var productTabIndicator = null;
    var productTabIndicatorFrame = null;

    function getNearestProductIndex() {
      if (!productCards.length) return 0;

      var firstOffset = productCards[0].offsetLeft;
      var currentOffset = productRail.scrollLeft + firstOffset;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      productCards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - currentOffset);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function getVisibleProductRange() {
      var railRect = productRail.getBoundingClientRect();
      var visibleIndexes = [];

      productCards.forEach(function (card, index) {
        var cardRect = card.getBoundingClientRect();
        if (cardRect.right > railRect.left + 2 && cardRect.left < railRect.right - 2) {
          visibleIndexes.push(index);
        }
      });

      if (!visibleIndexes.length) {
        var nearestIndex = getNearestProductIndex();
        return [nearestIndex, nearestIndex];
      }

      return [visibleIndexes[0], visibleIndexes[visibleIndexes.length - 1]];
    }

    function updateProductRailState() {
      productRailFrame = null;

      var maxScroll = Math.max(0, productRail.scrollWidth - productRail.clientWidth);
      var hasOverflow = maxScroll > 2;
      var atStart = !hasOverflow || productRail.scrollLeft <= 2;
      var atEnd = !hasOverflow || productRail.scrollLeft >= maxScroll - 2;

      productCarousel.toggleAttribute("data-tmf-product-overflow", hasOverflow);
      if (productControls) productControls.hidden = !hasOverflow;
      if (productPrev) productPrev.disabled = atStart;
      if (productNext) productNext.disabled = atEnd;

      if (productStatus) {
        var visibleRange = productCards.length ? getVisibleProductRange() : [-1, -1];
        var firstVisible = visibleRange[0] + 1;
        var lastVisible = visibleRange[1] + 1;
        var statusTemplate = productStatus.getAttribute("data-tmf-product-status-template");
        var nextStatus = statusTemplate
          ? statusTemplate
            .replace(/\[start\]|\{\{\s*first\s*\}\}/g, String(firstVisible))
            .replace(/\[end\]|\{\{\s*last\s*\}\}/g, String(lastVisible))
            .replace(/\[total\]|\{\{\s*total\s*\}\}/g, String(productCards.length))
          : (firstVisible === lastVisible
            ? firstVisible + " sur " + productCards.length
            : firstVisible + "-" + lastVisible + " sur " + productCards.length);

        if (productStatus.textContent !== nextStatus) productStatus.textContent = nextStatus;
        productStatus.dataset.tmfProductFirst = String(firstVisible);
        productStatus.dataset.tmfProductLast = String(lastVisible);
        productStatus.dataset.tmfProductTotal = String(productCards.length);
      }
    }

    function requestProductRailState() {
      if (productRailFrame) return;
      productRailFrame = window.requestAnimationFrame(updateProductRailState);
    }

    function scrollProductRail(left, smooth) {
      var reducedMotion = reducedMotionQuery ? reducedMotionQuery.matches : prefersReducedMotion;
      if (smooth && !reducedMotion) {
        productRail.scrollTo({ left: left, behavior: "smooth" });
        return;
      }

      // Override CSS scroll-behavior as well, so tab changes and reduced motion are immediate.
      var previousScrollBehavior = productRail.style.scrollBehavior;
      productRail.style.scrollBehavior = "auto";
      productRail.scrollTo({ left: left, behavior: "auto" });
      productRail.style.scrollBehavior = previousScrollBehavior;
    }

    function scrollToProduct(index) {
      if (!productCards.length) return;

      var safeIndex = Math.max(0, Math.min(productCards.length - 1, index));
      var targetLeft = productCards[safeIndex].offsetLeft - productCards[0].offsetLeft;
      scrollProductRail(targetLeft, true);
    }

    function moveProductRail(direction) {
      scrollToProduct(getNearestProductIndex() + direction);
    }

    function updateProductTabIndicator(animate) {
      if (!productTabIndicator) return;
      var activeTab = productTabs.find(function (tab) {
        return tab.getAttribute("data-tmf-product-category") === activeProductCategory;
      });
      if (!activeTab) return;

      var transform = "translateX(" + activeTab.offsetLeft + "px)";
      var width = activeTab.getBoundingClientRect().width + "px";
      if (productTabIndicator.style.transform === transform && productTabIndicator.style.width === width) return;

      if (!animate) productTabIndicator.style.transition = "none";
      productTabIndicator.style.transform = transform;
      productTabIndicator.style.width = width;
      if (!animate) {
        // Establish the initial or resized geometry before enabling click transitions.
        productTabIndicator.getBoundingClientRect();
        productTabIndicator.style.removeProperty("transition");
      }
    }

    function requestProductTabIndicator() {
      if (productTabIndicatorFrame) return;
      productTabIndicatorFrame = window.requestAnimationFrame(function () {
        productTabIndicatorFrame = null;
        updateProductTabIndicator(false);
      });
    }

    function displayProductCategory(tab) {
      var category = tab.getAttribute("data-tmf-product-category");
      if (!productCategoryContent[category]) return;

      if (category !== activeProductCategory) {
        resetProductDrag({ snap: false, suppressClick: false });
        suppressNextProductClick = false;

        // Move live nodes into their cache to preserve custom elements and selected swatches.
        while (productRail.firstChild) {
          productCategoryContent[activeProductCategory].appendChild(productRail.firstChild);
        }
        productRail.appendChild(productCategoryContent[category]);
        activeProductCategory = category;
        productCards = Array.prototype.slice.call(productRail.querySelectorAll("[data-tmf-product-card]"));
        scrollProductRail(0, false);
      }

      productTabs.forEach(function (productTab) {
        var selected = productTab === tab;
        productTab.classList.toggle("is-active", selected);
        productTab.setAttribute("aria-selected", String(selected));
        productTab.tabIndex = selected ? 0 : -1;
      });
      productRail.setAttribute("aria-labelledby", tab.id);
      productCarousel.setAttribute("data-tmf-product-category", category);
      updateProductTabIndicator(true);
      requestProductRailState();
    }

    function loadProductCategory(category) {
      if (productCategoryContent[category]) return Promise.resolve();
      if (productCategoryRequests[category]) return productCategoryRequests[category];

      var source;
      try {
        source = new URL(productCategorySources[category], window.location.href);
        if (source.origin !== window.location.origin || !/^https?:$/.test(source.protocol)) {
          throw new Error("Invalid product category source");
        }
      } catch (error) {
        return Promise.reject(error);
      }

      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
      var request = window.fetch(source.href, {
        credentials: "same-origin",
        headers: { Accept: "text/html" },
        signal: controller.signal
      }).then(function (response) {
        if (!response.ok || new URL(response.url).origin !== source.origin) {
          throw new Error("Product category unavailable");
        }
        return response.text();
      }).then(function (html) {
        var responseDocument = new DOMParser().parseFromString(html, "text/html");
        var categoryContainer = Array.prototype.find.call(
          responseDocument.querySelectorAll("[data-tmf-category-products]"),
          function (container) { return container.getAttribute("data-tmf-category-products") === category; }
        );
        var cards = categoryContainer ? Array.prototype.filter.call(categoryContainer.children, function (card) {
          return card.matches("[data-tmf-product-card]");
        }).slice(0, productCategoryLimit) : [];
        if (!cards.length) throw new Error("Product category response is empty");

        var content = document.createDocumentFragment();
        cards.forEach(function (card) { content.appendChild(document.importNode(card, true)); });
        productCategoryContent[category] = content;
      });

      // Cache one in-flight request per category; failed requests remain retryable.
      productCategoryRequests[category] = request.then(function () {
        window.clearTimeout(timeout);
        delete productCategoryRequests[category];
      }, function (error) {
        window.clearTimeout(timeout);
        delete productCategoryRequests[category];
        throw error;
      });
      return productCategoryRequests[category];
    }

    function selectProductCategory(tab) {
      var category = tab.getAttribute("data-tmf-product-category");
      var selection = ++productCategorySelection;
      if (productCategoryContent[category]) {
        productRail.removeAttribute("aria-busy");
        displayProductCategory(tab);
        return;
      }
      if (!productCategorySources[category]) return;

      // Keep current cards usable until the requested category is ready.
      productRail.setAttribute("aria-busy", "true");
      loadProductCategory(category).then(function () {
        if (selection !== productCategorySelection) return;
        productRail.removeAttribute("aria-busy");
        displayProductCategory(tab);
      }, function () {
        if (selection !== productCategorySelection) return;
        productRail.removeAttribute("aria-busy");
        // The collection link remains a complete fallback on timeout or failure.
        window.location.assign(tab.href);
      });
    }

    function focusProductTab(tab) {
      tab.focus({ preventScroll: true });
      var tabRect = tab.getBoundingClientRect();
      var listRect = productTabList.getBoundingClientRect();
      var scrollDelta = tabRect.left < listRect.left
        ? tabRect.left - listRect.left
        : Math.max(0, tabRect.right - listRect.right);
      if (!scrollDelta) return;

      var previousScrollBehavior = productTabList.style.scrollBehavior;
      productTabList.style.scrollBehavior = "auto";
      productTabList.scrollLeft += scrollDelta;
      productTabList.style.scrollBehavior = previousScrollBehavior;
    }

    // Keep the whole navigation as native links when remote tabs cannot be loaded.
    var canEnhanceProductTabs = !productCarousel.querySelector("template[data-tmf-product-source]") ||
      Boolean(window.fetch && window.AbortController);
    if (productTabs.length && canEnhanceProductTabs) {
      productCategoryContent[activeProductCategory] = document.createDocumentFragment();
      Array.prototype.forEach.call(
        productCarousel.querySelectorAll("template[data-tmf-product-template]"),
        function (template) {
          var category = template.getAttribute("data-tmf-product-template");
          if (category && category !== activeProductCategory) {
            var source = template.getAttribute("data-tmf-product-source");
            if (source) {
              productCategorySources[category] = source;
            } else {
              productCategoryContent[category] = document.createDocumentFragment();
              productCategoryContent[category].appendChild(template.content);
            }
          }
        }
      );

      productTabs = productTabs.filter(function (tab) {
        var category = tab.getAttribute("data-tmf-product-category");
        return Boolean(productCategoryContent[category] || productCategorySources[category]);
      });
      if (!productRail.id) productRail.id = "tmf-product-rail";
      productTabList.setAttribute("role", "tablist");
      productTabList.setAttribute("aria-orientation", "horizontal");
      productRail.setAttribute("role", "tabpanel");
      productRail.removeAttribute("aria-roledescription");

      productTabs.forEach(function (tab, index) {
        if (!tab.id) tab.id = productRail.id + "-tab-" + index;
        tab.setAttribute("role", "tab");
        tab.setAttribute("aria-controls", productRail.id);
        tab.addEventListener("click", function (event) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          selectProductCategory(tab);
        });
        tab.addEventListener("keydown", function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          var nextIndex = index;
          if (event.key === "ArrowLeft") nextIndex = (index - 1 + productTabs.length) % productTabs.length;
          else if (event.key === "ArrowRight") nextIndex = (index + 1) % productTabs.length;
          else if (event.key === "Home") nextIndex = 0;
          else if (event.key === "End") nextIndex = productTabs.length - 1;
          else if (event.key !== " " && event.key !== "Enter") return;

          event.preventDefault();
          selectProductCategory(productTabs[nextIndex]);
          focusProductTab(productTabs[nextIndex]);
        });
      });
      selectProductCategory(productTabs[0]);
      productTabList.hidden = false;
      productTabIndicator = document.createElement("span");
      productTabIndicator.className = "tmf-product-tab-indicator";
      productTabIndicator.setAttribute("aria-hidden", "true");
      productTabList.appendChild(productTabIndicator);
      updateProductTabIndicator(false);
      productTabList.setAttribute("data-tmf-product-indicator", "");
      productTabList.addEventListener("scroll", requestProductTabIndicator, { passive: true });
      window.addEventListener("resize", requestProductTabIndicator);
      if ("ResizeObserver" in window) {
        var productTabObserver = new ResizeObserver(requestProductTabIndicator);
        productTabObserver.observe(productTabList);
        productTabs.forEach(function (tab) { productTabObserver.observe(tab); });
      }
      if (document.fonts) {
        document.fonts.ready.then(requestProductTabIndicator);
        if (document.fonts.addEventListener) document.fonts.addEventListener("loadingdone", requestProductTabIndicator);
      }
    }

    function resetProductDrag(options) {
      var settings = options || {};
      var pointerId = productDragPointerId;
      var wasDragging = productDragActive;

      productDragPointerId = null;
      productDragActive = false;
      productRail.classList.remove("is-dragging");

      if (
        pointerId !== null &&
        productRail.hasPointerCapture &&
        productRail.hasPointerCapture(pointerId)
      ) {
        productRail.releasePointerCapture(pointerId);
      }

      if (!wasDragging) return;

      if (settings.suppressClick !== false) suppressNextProductClick = true;

      window.requestAnimationFrame(function () {
        if (settings.snap !== false) scrollToProduct(getNearestProductIndex());
        else requestProductRailState();
      });
    }

    function handleProductPointerDown(event) {
      suppressNextProductClick = false;
      if (event.pointerType === "touch" || !event.isPrimary || event.button !== 0) return;
      if (event.target.closest("button, input, select, textarea, label, [role='button'], [contenteditable='true'], [data-product-card-variant-rail]")) return;

      if (productDragPointerId !== null) resetProductDrag({ snap: false });

      productDragPointerId = event.pointerId;
      productDragStartX = event.clientX;
      productDragStartScrollLeft = productRail.scrollLeft;
      productDragActive = false;
    }

    function handleProductPointerMove(event) {
      if (event.pointerId !== productDragPointerId) return;

      var dragDistance = event.clientX - productDragStartX;

      if (!productDragActive) {
        if (Math.abs(dragDistance) < productDragThreshold) return;

        productDragActive = true;
        productRail.classList.add("is-dragging");

        if (productRail.setPointerCapture) {
          try {
            productRail.setPointerCapture(event.pointerId);
          } catch (error) {
            // The global pointer listeners keep the drag usable if capture is unavailable.
          }
        }
      }

      event.preventDefault();
      productRail.scrollLeft = productDragStartScrollLeft - dragDistance;
    }

    function handleProductPointerUp(event) {
      if (event.pointerId !== productDragPointerId) return;
      resetProductDrag({ suppressClick: productDragActive });
    }

    function handleProductPointerCancel(event) {
      if (event.pointerId !== productDragPointerId) return;
      resetProductDrag();
    }

    function handleProductPointerCaptureLost(event) {
      if (event.pointerId !== productDragPointerId) return;
      resetProductDrag();
    }

    function handleProductRailClick(event) {
      if (!suppressNextProductClick) return;

      suppressNextProductClick = false;
      event.preventDefault();
      event.stopPropagation();
    }

    if (productPrev) {
      productPrev.addEventListener("click", function () {
        moveProductRail(-1);
      });
    }

    if (productNext) {
      productNext.addEventListener("click", function () {
        moveProductRail(1);
      });
    }

    productRail.addEventListener("keydown", function (event) {
      if (event.target !== productRail) return;

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        moveProductRail(-1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        moveProductRail(1);
      } else if (event.key === "Home") {
        event.preventDefault();
        scrollToProduct(0);
      } else if (event.key === "End") {
        event.preventDefault();
        scrollToProduct(productCards.length - 1);
      }
    });

    productRail.addEventListener("scroll", requestProductRailState, { passive: true });
    productRail.addEventListener("pointerdown", handleProductPointerDown);
    productRail.addEventListener("lostpointercapture", handleProductPointerCaptureLost);
    productRail.addEventListener("click", handleProductRailClick, true);
    productRail.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });
    window.addEventListener("pointermove", handleProductPointerMove, { passive: false });
    window.addEventListener("pointerup", handleProductPointerUp);
    window.addEventListener("pointercancel", handleProductPointerCancel);
    window.addEventListener("blur", function () {
      if (productDragPointerId !== null) resetProductDrag();
    });
    window.addEventListener("resize", requestProductRailState);

    if ("ResizeObserver" in window) {
      var productRailObserver = new ResizeObserver(requestProductRailState);
      productRailObserver.observe(productRail);
    }

    updateProductRailState();
    window.addEventListener("load", requestProductRailState, { once: true });
  }

  var floatingImages = root.querySelectorAll("[data-tmf-parallax]");
  var statements = Array.prototype.slice.call(root.querySelectorAll("[data-tmf-statement]"));
  var keeperCards = root.querySelectorAll("[data-tmf-keeper-card]");
  var keeperViewport = root.querySelector(".tmf-keeper__sticky");
  var ticking = false;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function easeInOut(progress) {
    return progress * progress * (3 - 2 * progress);
  }

  function initLiquidGradientWebGL(hero, canvas) {
    var gl = null;
    try {
      gl = canvas.getContext("webgl2", {
        alpha: false,
        antialias: false,
        depth: false,
        powerPreference: "low-power",
        premultipliedAlpha: false,
        preserveDrawingBuffer: false,
        stencil: false,
      });
    } catch (error) {
      gl = null;
    }

    if (!gl) return false;

    var vertexSource =
      "#version 300 es\n" +
      "in vec2 a_position;\n" +
      "out vec2 v_uv;\n" +
      "void main() {\n" +
      "  v_uv = a_position * 0.5 + 0.5;\n" +
      "  gl_Position = vec4(a_position, 0.0, 1.0);\n" +
      "}\n";

    var fragmentSource =
      "#version 300 es\n" +
      "precision highp float;\n" +
      "precision highp int;\n" +
      "const float GOLDEN_ANGLE = 2.3999632;\n" +
      "const float TAU = 6.28318530;\n" +
      "in vec2 v_uv;\n" +
      "out vec4 fragColor;\n" +
      "uniform vec2 u_resolution;\n" +
      "uniform float u_time;\n" +
      "uniform float u_pixelRatio;\n" +
      "uniform int u_colors_length;\n" +
      "uniform vec4 u_colors[8];\n" +
      "uniform float u_seed;\n" +
      "uniform float u_speed;\n" +
      "uniform float u_scale;\n" +
      "uniform float u_turbAmp;\n" +
      "uniform float u_turbFreq;\n" +
      "uniform float u_turbIter;\n" +
      "uniform float u_waveFreq;\n" +
      "uniform float u_distBias;\n" +
      "uniform float u_dither;\n" +
      "uniform float u_ditherMode;\n" +
      "uniform float u_exposure;\n" +
      "uniform float u_contrast;\n" +
      "uniform float u_saturation;\n" +
      "uniform float u_loop;\n" +
      "uniform float u_jellify;\n" +
      "uvec3 hash3(uvec3 v) {\n" +
      "  v = v * 1664525u + 1013904223u;\n" +
      "  v.x += v.y * v.z;\n" +
      "  v.y += v.z * v.x;\n" +
      "  v.z += v.x * v.y;\n" +
      "  v ^= v >> 16u;\n" +
      "  v.x += v.y * v.z;\n" +
      "  v.y += v.z * v.x;\n" +
      "  v.z += v.x * v.y;\n" +
      "  return v;\n" +
      "}\n" +
      "vec3 seedRandom(float seedVal) {\n" +
      "  uvec3 s = uvec3(floatBitsToUint(seedVal), floatBitsToUint(seedVal * 1.5 + 7.31), floatBitsToUint(seedVal * 2.7 + 13.37));\n" +
      "  s = hash3(s);\n" +
      "  return vec3(s) / float(0xFFFFFFFFu);\n" +
      "}\n" +
      "vec3 toLinear(vec3 c) { return pow(c, vec3(2.2)); }\n" +
      "vec3 toSrgb(vec3 c) { return pow(clamp(c, 0.0, 1.0), vec3(0.4545)); }\n" +
      "vec3 linearToOklab(vec3 c) {\n" +
      "  float l = 0.4122214708 * c.r + 0.5363325363 * c.g + 0.0514459929 * c.b;\n" +
      "  float m = 0.2119034982 * c.r + 0.6806995451 * c.g + 0.1073969566 * c.b;\n" +
      "  float s = 0.0883024619 * c.r + 0.2817188376 * c.g + 0.6299787005 * c.b;\n" +
      "  l = pow(max(l, 0.0), 1.0 / 3.0);\n" +
      "  m = pow(max(m, 0.0), 1.0 / 3.0);\n" +
      "  s = pow(max(s, 0.0), 1.0 / 3.0);\n" +
      "  return vec3(0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s, 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s, 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s);\n" +
      "}\n" +
      "vec3 oklabToLinear(vec3 c) {\n" +
      "  float l = c.x + 0.3963377774 * c.y + 0.2158037573 * c.z;\n" +
      "  float m = c.x - 0.1055613458 * c.y - 0.0638541728 * c.z;\n" +
      "  float s = c.x - 0.0894841775 * c.y - 1.2914855480 * c.z;\n" +
      "  l = l * l * l;\n" +
      "  m = m * m * m;\n" +
      "  s = s * s * s;\n" +
      "  return vec3(+4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s, -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s, -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s);\n" +
      "}\n" +
      "vec3 oklabToLch(vec3 lab) { return vec3(lab.x, length(lab.yz), atan(lab.z, lab.y)); }\n" +
      "vec3 lchToOklab(vec3 lch) { return vec3(lch.x, lch.y * cos(lch.z), lch.y * sin(lch.z)); }\n" +
      "vec3 mixLch(vec3 lab0, vec3 lab1, float t) {\n" +
      "  vec3 lch0 = oklabToLch(lab0);\n" +
      "  vec3 lch1 = oklabToLch(lab1);\n" +
      "  if (lch0.y < 0.05) lch0.z = lch1.z;\n" +
      "  if (lch1.y < 0.05) lch1.z = lch0.z;\n" +
      "  float dh = lch1.z - lch0.z;\n" +
      "  if (dh > 3.14159265) dh -= TAU;\n" +
      "  if (dh < -3.14159265) dh += TAU;\n" +
      "  return lchToOklab(vec3(mix(lch0.x, lch1.x, t), mix(lch0.y, lch1.y, t), lch0.z + dh * t));\n" +
      "}\n" +
      "vec3 getColor(int idx) {\n" +
      "  if (u_colors_length < 1) return vec3(0.0);\n" +
      "  int safeIdx = clamp(idx, 0, u_colors_length - 1);\n" +
      "  return u_colors[safeIdx].rgb;\n" +
      "}\n" +
      "vec3 paletteN(float t, int count) {\n" +
      "  if (count < 1) return vec3(0.0);\n" +
      "  if (count < 2) return toLinear(getColor(0));\n" +
      "  float segmentSize = 1.0 / float(count - 1);\n" +
      "  t = clamp(t, 0.0, 1.0);\n" +
      "  int idx = min(int(floor(t / segmentSize)), count - 2);\n" +
      "  float localT = clamp((t - float(idx) * segmentSize) / segmentSize, 0.0, 1.0);\n" +
      "  vec3 lab0 = linearToOklab(toLinear(getColor(idx)));\n" +
      "  vec3 lab1 = linearToOklab(toLinear(getColor(idx + 1)));\n" +
      "  return oklabToLinear(mixLch(lab0, lab1, localT));\n" +
      "}\n" +
      "float IGN(vec2 uv) { return fract(52.9829189 * fract(dot(uv, vec2(0.06711056, 0.00583715)))); }\n" +
      "float quickNoise(vec2 I) { return fract(sin(dot(I, vec2(12.9898, 78.233))) * 43758.5453); }\n" +
      "float getDither(vec2 I, float mode) {\n" +
      "  if (mode < 0.5) return 0.5;\n" +
      "  if (mode < 1.5) return IGN(I);\n" +
      "  return quickNoise(I);\n" +
      "}\n" +
      "vec3 softGamutMap(vec3 linearRgb) {\n" +
      "  float maxC = max(linearRgb.r, max(linearRgb.g, linearRgb.b));\n" +
      "  float minC = min(linearRgb.r, min(linearRgb.g, linearRgb.b));\n" +
      "  if (minC >= 0.0 && maxC <= 1.0) return linearRgb;\n" +
      "  vec3 lab = linearToOklab(max(linearRgb, 0.0));\n" +
      "  float L = clamp(lab.x, 0.0, 1.0);\n" +
      "  float C = length(lab.yz);\n" +
      "  float h = atan(lab.z, lab.y);\n" +
      "  float maxChroma = 0.4 * (1.0 - pow(abs(2.0 * L - 1.0), 2.0));\n" +
      "  if (C > maxChroma * 0.7) {\n" +
      "    float knee = maxChroma * 0.7;\n" +
      "    C = knee + (maxChroma - knee) * tanh((C - knee) / (maxChroma - knee + 0.001));\n" +
      "  }\n" +
      "  return clamp(oklabToLinear(vec3(L, C * cos(h), C * sin(h))), 0.0, 1.0);\n" +
      "}\n" +
      "vec3 applyContrastSaturation(vec3 linearRgb, float contrast, float saturation) {\n" +
      "  vec3 lab = linearToOklab(linearRgb);\n" +
      "  float C = length(lab.yz);\n" +
      "  float h = atan(lab.z, lab.y);\n" +
      "  lab.x = clamp((lab.x - 0.5) * contrast + 0.5, 0.0, 1.0);\n" +
      "  C *= saturation;\n" +
      "  lab.y = C * cos(h);\n" +
      "  lab.z = C * sin(h);\n" +
      "  return oklabToLinear(lab);\n" +
      "}\n" +
      "void main() {\n" +
      "  vec2 fragCoord = v_uv * u_resolution;\n" +
      "  vec2 r = u_resolution;\n" +
      "  vec2 p = (fragCoord * 2.0 - r) / r.y;\n" +
      "  int colorCount = u_colors_length;\n" +
      "  if (colorCount < 1) {\n" +
      "    fragColor = vec4(0.0, 0.0, 0.0, 1.0);\n" +
      "    return;\n" +
      "  }\n" +
      "  float t = u_time * 0.3;\n" +
      "  float looping = step(0.5, u_loop);\n" +
      "  float phase = TAU * u_time / max(u_loop, 0.01);\n" +
      "  float radius = u_loop * u_speed * 0.3 / TAU;\n" +
      "  float tA = sin(phase) * radius;\n" +
      "  float tB = (1.0 - cos(phase)) * radius;\n" +
      "  vec3 seedOffset = seedRandom(u_seed);\n" +
      "  vec3 seedOffset2 = seedRandom(u_seed + 100.0);\n" +
      "  float seedAngle = u_seed * GOLDEN_ANGLE;\n" +
      "  vec2 seedPhase = (seedOffset2.xy - 0.5) * TAU;\n" +
      "  float cs = cos(seedAngle);\n" +
      "  float sn = sin(seedAngle);\n" +
      "  p = mat2(cs, -sn, sn, cs) * p;\n" +
      "  float dither = getDither(floor(fragCoord / u_pixelRatio), u_ditherMode);\n" +
      "  float totalVal = 0.0;\n" +
      "  float totalWeight = 0.0;\n" +
      "  int turbIter = int(u_turbIter);\n" +
      "  float freq = 1.0 / max(u_turbFreq, 0.01);\n" +
      "  for (float i = 0.0; i < 4.0; i++) {\n" +
      "    float eph = i / 4.0;\n" +
      "    vec2 q = p * u_scale;\n" +
      "    float sq = eph * eph;\n" +
      "    if (u_jellify > 0.5) q.yx *= mix(1.0, 0.5, 1.0 - exp(-sq));\n" +
      "    float a = seedPhase.x;\n" +
      "    float d = seedPhase.y;\n" +
      "    for (int j = 2; j < 13; j++) {\n" +
      "      if (j >= turbIter) break;\n" +
      "      float fj = float(j);\n" +
      "      float t1 = mix(t * u_speed, tA, looping);\n" +
      "      float t2 = mix(t * u_speed, tB, looping);\n" +
      "      q += u_turbAmp * sin(q.yx / freq * fj + t1 + vec2(a, d) + seedOffset.xy * fj) / fj;\n" +
      "      a += cos(fj + d * 1.2 + q.x * 2.0 - t1 + seedOffset2.z + t2 * 0.3 * looping);\n" +
      "      d += sin(fj * q.y + a + seedOffset.z + t1 + seedOffset2.y + t2 * 0.3 * looping);\n" +
      "    }\n" +
      "    float v = 0.5 + 0.5 * sin(length(q.yx + vec2(a, d) * 0.2) * u_waveFreq + i * i + seedOffset.x);\n" +
      "    float weight = smoothstep(0.0, 0.5, eph) * (1.0 - smoothstep(0.5, 1.0, eph));\n" +
      "    totalVal += v * weight;\n" +
      "    totalWeight += weight;\n" +
      "  }\n" +
      "  float val = totalVal / max(totalWeight, 0.0001);\n" +
      "  val = clamp((val - 0.3) / 0.4, 0.0, 1.0);\n" +
      "  val = pow(val, exp(-u_distBias));\n" +
      "  val = clamp(val + (dither - 0.5) * u_dither, 0.0, 1.0);\n" +
      "  vec3 col = paletteN(val, colorCount);\n" +
      "  col *= u_exposure;\n" +
      "  col = applyContrastSaturation(col, u_contrast, u_saturation);\n" +
      "  col = softGamutMap(col);\n" +
      "  col = toSrgb(col);\n" +
      "  fragColor = vec4(col, 1.0);\n" +
      "}\n";

    function compileShader(type, source) {
      var shader = gl.createShader(type);
      if (!shader) return null;
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    function createProgram() {
      var vertexShader = compileShader(gl.VERTEX_SHADER, vertexSource);
      var fragmentShader = compileShader(gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertexShader || !fragmentShader) return null;

      var shaderProgram = gl.createProgram();
      if (!shaderProgram) return null;

      gl.attachShader(shaderProgram, vertexShader);
      gl.attachShader(shaderProgram, fragmentShader);
      gl.linkProgram(shaderProgram);
      gl.deleteShader(vertexShader);
      gl.deleteShader(fragmentShader);

      if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        gl.deleteProgram(shaderProgram);
        return null;
      }

      return shaderProgram;
    }

    var program = createProgram();
    if (!program) return false;

    var locations = {
      position: gl.getAttribLocation(program, "a_position"),
      resolution: gl.getUniformLocation(program, "u_resolution"),
      time: gl.getUniformLocation(program, "u_time"),
      pixelRatio: gl.getUniformLocation(program, "u_pixelRatio"),
      colorsLength: gl.getUniformLocation(program, "u_colors_length"),
      colors: gl.getUniformLocation(program, "u_colors[0]"),
      seed: gl.getUniformLocation(program, "u_seed"),
      speed: gl.getUniformLocation(program, "u_speed"),
      scale: gl.getUniformLocation(program, "u_scale"),
      turbAmp: gl.getUniformLocation(program, "u_turbAmp"),
      turbFreq: gl.getUniformLocation(program, "u_turbFreq"),
      turbIter: gl.getUniformLocation(program, "u_turbIter"),
      waveFreq: gl.getUniformLocation(program, "u_waveFreq"),
      distBias: gl.getUniformLocation(program, "u_distBias"),
      dither: gl.getUniformLocation(program, "u_dither"),
      ditherMode: gl.getUniformLocation(program, "u_ditherMode"),
      exposure: gl.getUniformLocation(program, "u_exposure"),
      contrast: gl.getUniformLocation(program, "u_contrast"),
      saturation: gl.getUniformLocation(program, "u_saturation"),
      loop: gl.getUniformLocation(program, "u_loop"),
      jellify: gl.getUniformLocation(program, "u_jellify"),
    };

    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);

    gl.useProgram(program);
    gl.enableVertexAttribArray(locations.position);
    gl.vertexAttribPointer(locations.position, 2, gl.FLOAT, false, 0, 0);

    var colorUniforms = new Float32Array([
      0 / 255, 128 / 255, 255 / 255, 1,
      245 / 255, 248 / 255, 255 / 255, 1,
      64 / 255, 188 / 255, 255 / 255, 1,
      255 / 255, 184 / 255, 181 / 255, 1,
      255 / 255, 194 / 255, 242 / 255, 1,
      0, 0, 0, 1,
      0, 0, 0, 1,
      0, 0, 0, 1,
    ]);

    var hardwareConcurrency = navigator.hardwareConcurrency || 8;
    var targetFps = hardwareConcurrency <= 4 ? 24 : 30;
    var frameInterval = 1000 / targetFps;
    // The translucent background does not need the resolution of foreground media.
    var maxRenderedPixels = hardwareConcurrency <= 4 ? 240000 : 480000;
    var maxPixelRatio = 1;
    var animationFrame = null;
    var resizeFrame = null;
    var lastFrame = -Infinity;
    var isPageVisible = document.visibilityState !== "hidden";
    var heroRect = hero.getBoundingClientRect();
    var isHeroVisible = heroRect.bottom > -160 && heroRect.top < window.innerHeight + 160;
    var renderWidth = 0;
    var renderHeight = 0;
    var renderPixelRatio = 1;
    var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) || 4096;
    var resizeObserver = null;
    var heroObserver = null;

    gl.uniform1i(locations.colorsLength, 5);
    gl.uniform4fv(locations.colors, colorUniforms);
    gl.uniform1f(locations.seed, 648);
    gl.uniform1f(locations.speed, 0.3);
    gl.uniform1f(locations.scale, 0.42);
    gl.uniform1f(locations.turbAmp, 0.6);
    gl.uniform1f(locations.turbFreq, 0.1);
    gl.uniform1f(locations.turbIter, 7);
    gl.uniform1f(locations.waveFreq, 3.8);
    gl.uniform1f(locations.distBias, 0);
    gl.uniform1f(locations.dither, 0.05);
    gl.uniform1f(locations.ditherMode, 0);
    gl.uniform1f(locations.exposure, 1.1);
    gl.uniform1f(locations.contrast, 1.1);
    gl.uniform1f(locations.saturation, 1);
    gl.uniform1f(locations.loop, 0);
    gl.uniform1f(locations.jellify, 0);

    function resizeLiquidGradient() {
      var rect = canvas.getBoundingClientRect();
      var width = Math.max(1, rect.width || hero.offsetWidth || window.innerWidth);
      var height = Math.max(1, rect.height || hero.offsetHeight || window.innerHeight);
      var budgetRatio = Math.sqrt(maxRenderedPixels / Math.max(1, width * height));
      var pixelRatio = Math.min(window.devicePixelRatio || 1, maxPixelRatio, budgetRatio);
      pixelRatio = Math.min(pixelRatio, maxTextureSize / width, maxTextureSize / height);
      var targetWidth = Math.max(1, Math.min(Math.floor(width * pixelRatio), maxTextureSize));
      var targetHeight = Math.max(1, Math.min(Math.floor(height * pixelRatio), maxTextureSize));

      if (targetWidth === renderWidth && targetHeight === renderHeight && pixelRatio === renderPixelRatio) return;

      renderWidth = targetWidth;
      renderHeight = targetHeight;
      renderPixelRatio = pixelRatio;
      canvas.width = renderWidth;
      canvas.height = renderHeight;
      gl.viewport(0, 0, renderWidth, renderHeight);
      gl.uniform2f(locations.resolution, renderWidth, renderHeight);
      gl.uniform1f(locations.pixelRatio, renderPixelRatio);
      canvas.dataset.tmfLiquidScale = renderPixelRatio.toFixed(2);
    }

    function drawLiquidGradient(seconds) {
      gl.uniform1f(locations.time, seconds || 0);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
    }

    function canAnimate() {
      return hasEnhancedMotion() && isPageVisible && isHeroVisible;
    }

    function queueAnimation() {
      if (!animationFrame && canAnimate()) {
        animationFrame = window.requestAnimationFrame(render);
      }
    }

    function stopAnimation() {
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    function render(now) {
      animationFrame = null;
      if (!canAnimate()) return;

      if (now - lastFrame >= frameInterval) {
        drawLiquidGradient((now || 0) / 1000);
        lastFrame = now;
      }

      queueAnimation();
    }

    function drawCurrentFrame() {
      var now = window.performance ? window.performance.now() : 0;
      resizeLiquidGradient();
      drawLiquidGradient(now / 1000);
      lastFrame = now;
    }

    function requestLiquidFrame() {
      if (resizeFrame) return;

      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = null;
        if (canAnimate()) drawCurrentFrame();
      });
    }

    canvas.dataset.tmfLiquidRenderer = "webgl2";
    canvas.dataset.tmfLiquidFps = String(targetFps);
    drawCurrentFrame();
    hero.classList.add("tmf-hero--liquid-ready");
    queueAnimation();

    if ("IntersectionObserver" in window) {
      heroObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;

          isHeroVisible = entry.isIntersecting;
          if (canAnimate()) {
            drawCurrentFrame();
            queueAnimation();
          } else {
            stopAnimation();
          }
        },
        { rootMargin: "160px 0px" }
      );
      heroObserver.observe(hero);
    }

    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(requestLiquidFrame);
      resizeObserver.observe(hero);
    } else {
      window.addEventListener("resize", requestLiquidFrame);
    }

    canvas.addEventListener("webglcontextlost", function (event) {
      event.preventDefault();
      stopAnimation();
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      if (resizeObserver) resizeObserver.disconnect();
      if (heroObserver) heroObserver.disconnect();
      resizeFrame = null;
      hero.classList.remove("tmf-hero--liquid-ready");
      canvas.remove();
    });

    document.addEventListener("visibilitychange", function () {
      isPageVisible = document.visibilityState !== "hidden";
      if (canAnimate()) {
        drawCurrentFrame();
        queueAnimation();
      } else {
        stopAnimation();
      }
    });

    function handleLiquidMotionChange() {
      if (canAnimate()) {
        drawCurrentFrame();
        queueAnimation();
      } else {
        stopAnimation();
      }
    }

    listenForMediaChange(reducedMotionQuery, handleLiquidMotionChange);
    listenForMediaChange(desktopMotionQuery, handleLiquidMotionChange);
    if (connection && connection.addEventListener) connection.addEventListener("change", handleLiquidMotionChange);

    return true;
  }

  function initLiquidGradient() {
    var hero = root.querySelector(".tmf-hero");
    if (!hero || !window.HTMLCanvasElement || !hasEnhancedMotion() || hero.querySelector(".tmf-liquid-gradient")) return;

    var canvas = document.createElement("canvas");
    canvas.className = "tmf-liquid-gradient";
    canvas.setAttribute("aria-hidden", "true");
    hero.insertBefore(canvas, hero.firstChild);

    if (!initLiquidGradientWebGL(hero, canvas)) {
      canvas.remove();
    }
  }

  var liquidGradientScheduled = false;

  function scheduleLiquidGradient() {
    if (liquidGradientScheduled || !hasEnhancedMotion()) return;
    liquidGradientScheduled = true;

    function runLiquidGradientInit() {
      liquidGradientScheduled = false;
      initLiquidGradient();
    }

    function queueLiquidGradientInit() {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(runLiquidGradientInit, { timeout: 1000 });
      } else {
        window.setTimeout(runLiquidGradientInit, 0);
      }
    }

    // Let the homepage entrance finish before compiling the decorative shader.
    if (root.querySelector(".tmf-hero--discovery-first")) {
      function waitForHeroEntrance() {
        window.setTimeout(queueLiquidGradientInit, 750);
      }
      if (document.readyState === "complete") waitForHeroEntrance();
      else window.addEventListener("load", waitForHeroEntrance, { once: true });
    } else {
      queueLiquidGradientInit();
    }
  }

  scheduleLiquidGradient();

  function resetEnhancedParallax() {
    floatingImages.forEach(function (el) {
      el.style.setProperty("--tmf-parallax", "0px");
    });

    statements.forEach(function (statement) {
      statement.style.setProperty("--tmf-bag-scroll-scale", "1");
    });
  }

  function updateParallax() {
    var enhancedMotion = hasEnhancedMotion();
    var keeperMotion = hasKeeperMotion();
    var styleUpdates = [];
    // Match the stable mobile scene height when browser toolbars expand or collapse.
    var keeperHeight = keeperMotion && !enhancedMotion && keeperViewport
      ? keeperViewport.clientHeight
      : window.innerHeight;

    function queueStyle(el, property, value) {
      if (el.style.getPropertyValue(property) !== value) {
        styleUpdates.push({ el: el, property: property, value: value });
      }
    }

    if (enhancedMotion) {
      floatingImages.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var distance = center - window.innerHeight / 2;
        var speed = Number(el.getAttribute("data-tmf-parallax")) || 0.08;
        queueStyle(el, "--tmf-parallax", Math.round(distance * speed * -1) + "px");
      });

      statements.forEach(function (statement) {
        var rect = statement.getBoundingClientRect();
        var start = window.innerHeight * 0.95;
        var end = window.innerHeight * 0.22;
        var progress = clamp((start - rect.top) / (start - end), 0, 1);
        var scale = 1.18 - easeInOut(progress) * 0.18;

        queueStyle(statement, "--tmf-bag-scroll-scale", scale.toFixed(4));
      });
    }

    keeperCards.forEach(function (card) {
      if (!keeperMotion) {
        queueStyle(card, "--tmf-keeper-scale", "1");
        return;
      }

      var rect = card.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var start = keeperHeight * 1.3;
      var end = keeperHeight * 0.68;
      var progress = clamp((start - center) / (start - end), 0, 1);
      var scale = 0.6 + progress * 0.4;

      queueStyle(card, "--tmf-keeper-scale", scale.toFixed(4));
    });

    // Finish all geometry reads before invalidating styles for the next frame.
    styleUpdates.forEach(function (update) {
      update.el.style.setProperty(update.property, update.value);
    });

    ticking = false;
  }

  function requestParallax() {
    if ((hasEnhancedMotion() || hasKeeperMotion()) && !ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  var continuousMotionSections = Array.prototype.slice.call(
    root.querySelectorAll(".tmf-hero__media, .tmf-logo-band, .tmf-brand-streams")
  );
  var continuousMotionObserver = null;

  function syncContinuousMotionSection(section) {
    var isVisible = section.dataset.tmfMotionVisible !== "false";
    var motionAllowed = section.matches(".tmf-hero__media, .tmf-logo-band")
      ? hasHeroMotion()
      : hasEnhancedMotion();
    section.classList.toggle("is-tmf-motion-paused", !motionAllowed || !isVisible);
  }

  function syncContinuousMotion() {
    continuousMotionSections.forEach(syncContinuousMotionSection);
  }

  if ("IntersectionObserver" in window && continuousMotionSections.length) {
    continuousMotionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.tmfMotionVisible = entry.isIntersecting ? "true" : "false";
          syncContinuousMotionSection(entry.target);
        });
      },
      { rootMargin: "160px 0px" }
    );

    continuousMotionSections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      section.dataset.tmfMotionVisible = rect.bottom > -160 && rect.top < window.innerHeight + 160 ? "true" : "false";
    });
    continuousMotionSections.forEach(function (section) {
      syncContinuousMotionSection(section);
      continuousMotionObserver.observe(section);
    });
  } else {
    continuousMotionSections.forEach(function (section) {
      section.dataset.tmfMotionVisible = "true";
    });
  }

  function syncMotionPreferences() {
    prefersReducedMotion = Boolean(reducedMotionQuery && reducedMotionQuery.matches);
    var enhancedMotion = hasEnhancedMotion();
    root.dataset.tmfMotion = enhancedMotion ? "enhanced" : "static";
    root.dataset.tmfHeroMotion = hasHeroMotion() ? "enhanced" : "static";
    root.dataset.tmfKeeperMotion = hasKeeperMotion() ? "enhanced" : "static";
    syncContinuousMotion();
    if (!enhancedMotion) resetEnhancedParallax();
    updateParallax();
    if (enhancedMotion) {
      scheduleLiquidGradient();
    } else {
      var liquidGradient = root.querySelector(".tmf-liquid-gradient");
      if (liquidGradient) liquidGradient.remove();
      var liquidHero = root.querySelector(".tmf-hero--liquid-ready");
      if (liquidHero) liquidHero.classList.remove("tmf-hero--liquid-ready");
    }
  }

  listenForMediaChange(reducedMotionQuery, syncMotionPreferences);
  listenForMediaChange(desktopMotionQuery, syncMotionPreferences);

  if (connection && connection.addEventListener) {
    connection.addEventListener("change", function () {
      saveData = Boolean(connection.saveData);
      syncMotionPreferences();
    });
  }

  syncMotionPreferences();
  window.addEventListener("scroll", requestParallax, { passive: true });
  window.addEventListener("resize", requestParallax);
})();
